//====================================================
//  Function: Registartion
//====================================================
function componentRegistration() {
  if ($(".in-registracia").length || $(".in-registrace").length) {
    $(".content-inner").wrapInner(
      '<div class="row content-block log-reg-block"><div class="col-12 col-lg-6 registration-block"><div class="popup-widget-inner"></div></div></div>'
    );

    $(".content-inner .content-block").prepend(
      '<div class="col-12 col-lg-6 login-block"></div>'
    );

    $(".content-inner .login-block").append(
      $(".user-action-login .popup-widget-inner")
    );

    $(".breadcrumbs #navigation-1 span").text(registrationBread);

    $(".login-block h2").text(registrationTitle);

    $(".registration-block .btn-login")
      .removeClass("btn-secondary")
      .addClass("btn-primary")
      .val(registrationReg);

    $(".login-block .email input")
      .attr("id", "login_email")
      .attr("placeholder", "");
    $(".login-block .email").prepend('<label for="login_email">Email</label>');

    $(".login-block .password input")
      .attr("id", "login_password")
      .attr("placeholder", "");
    $(".login-block .password").prepend(
      '<label for="login_password">Heslo</label>'
    );

    $(".social-login-buttons-divider").text(registrationFB);

    $(".login-btn.facebook strong").html(registrationFBLink);

    $(".login-block .password-helper a:last-child").text(registrationForgot);
  }

  if ($(".in-login").length) {
    $(".content-inner").wrapInner(
      '<div class="row content-block log-reg-block"><div class="col-12 login-block"></div></div>'
    );

    $(".login-block h2").text(registrationTitle);

    $(".login-block .email input")
      .attr("id", "login_email")
      .attr("placeholder", "");
    $(".login-block .email").prepend('<label for="login_email">Email</label>');

    $(".login-block .password input")
      .attr("id", "login_password")
      .attr("placeholder", "");
    $(".login-block .password").prepend(
      '<label for="login_password">Heslo</label>'
    );

    $(".social-login-buttons-divider").text(registrationFB);

    $(".login-btn.facebook strong").html(registrationFBLink);

    $(".login-block .password-helper a:last-child").text(registrationForgot);
  }

  if ($(".in-objednavky").length) {
    $(".cart-table").wrap('<div class="cart-table-group""></div>');
  }
}
